import { ListItem, Text, UnorderedList } from '@stars-ecom/shared-atoms-ui'
import isNil from 'lodash/isNil'
import React, { memo, useContext, useEffect, useMemo } from 'react'

import { DataLayerUtils, WebsiteContext } from '../../context'
import { priceFormat, getMultipaymentPrice } from '../../utils'
import PopoverInfo from '../PopoverInfo'

const _PopoverMultiPayment = (props) => {
  const { price, currency = 'EUR', product, multipaymentData = [], multipaymentEligibility = false } = props
  const websiteContext = useContext(WebsiteContext)

  const multipayment = getMultipaymentPrice(price, multipaymentData)

  useEffect(() => {
    DataLayerUtils.addEvent({
      event: 'qwampEventLab',
      eventCat: 'Pages produit',
      eventAct: 'Ouverture popin facilité paiement',
      eventLab: product?.customFields?.externalCode
    })
  }, [])
  if (isNil(multipayment)) {
    return null
  }
  return (
    <PopoverInfo
      labelButton={
        <p style={{ color: "#000", fontFamily: 'PT Sans Narrow,PT Sans,Arial,sans-serif', fontSize:"25px", fontWeight:'700',  lineHeight: '30px' }}>
          <span style={{ fontSize: "33px" }}>
            {priceFormat(multipayment.installment, currency)}
          </span> x<span style={{ }}>{multipayment.count}</span>
        </p>
}
      fontSize="14px"
      color="#000"
      >
      <Text
        style={{
          fontSize: '13px',
          color: '#242a30',
          fontFamily: 'PT Sans Narrow,PT Sans,Arial,sans-serif',
          paddingRight: '15px'
        }}>
        Pour tout paiement par carte bancaire, vous pouvez régler votre commande en plusieurs fois
        (paiement fractionné) :
      </Text>
      <UnorderedList
        className="bullet"
        style={{
          fontSize: '13px',
          color: '#242a30',
          fontFamily: 'PT Sans Narrow,PT Sans,Arial,sans-serif'
        }}>
        {multipaymentData?.map((item, i) => (
          <ListItem key={`item_${i}`} _before={{ color: websiteContext?.mainColor }}>
            En{' '}
            <strong>
              <span style={{ color: websiteContext?.mainColor, fontSize: '16px' }}>
                {item.count}x
              </span>{' '}
              dès {priceFormat(item.min, 'EUR')}
            </strong>{' '}
            d&acute;achat,
          </ListItem>
        ))}
      </UnorderedList>
      <Text
        style={{
          marginTop: '5px',
          width: '100%',
          fontSize: '12px',
          color: '#242a30',
          fontFamily: 'PT Sans Narrow,PT Sans,Arial,sans-serif',
          backgroundColor: '#eef4ff',
          padding: '10px',
          textAlign: 'justify'
        }}>
        {`${
          multipayment.applicationFee
            ? `Ce service vous sera facturé ${priceFormat(
                multipayment.applicationFee,
                'EUR'
              )} pour participation aux frais de dossiers et
        traitement. `
            : ''
        }Le paiement des mensualités s'organise comme suit : sur la 1ère
        mensualité, nous prélevons l'intégralité des frais de port de votre commande,
        les frais de dossier ainsi que le montant des articles expédiés divisé par le nombre
        de mensualités choisies. L'échéancier mensuel débute à la date
        d'expédition de chaque colis, le nombre d'échéances étant défini en
        fonction de la durée proposée.`}
      </Text>
    </PopoverInfo>
  )
}

const PopoverMultiPayment = memo(_PopoverMultiPayment)

export { PopoverMultiPayment }
